// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/widgets/web/7617/js/" + chunkId + ".chunk.js";
};